//header
import React, { Component } from "react";
import { LinearGradient } from "expo-linear-gradient";
import styles from "../styles/headerStyle";
import { View, Text, Platform, Image, TouchableOpacity } from "react-native";
import HocComponent from "./Hoc";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const resHeaderTextCenter = `headerTextCenter_${this.props.measure}`;
    const closeView = `closeView_${this.props.measure}`;

    return (
      <View>
        {this.props.showHeader && (
          <LinearGradient
            start={[0.0, 0.5]}
            start={[0.0, 0.5]}
            end={[1.0, 0.5]}
            colors={["#bc1a2a", "#f37022"]}
          >
            <View
              style={
                this.props.popupClose
                  ? styles.popupHeaderView
                  : styles.headerView
              }
            >
              <Text
                style={
                  this.props.popupClose
                    ? [styles.headertextCenter, styles[resHeaderTextCenter]]
                    : styles.headertext
                }
              >
                {this.props.headerText}
              </Text>
              {this.props.popupClose && (
                <View style={[styles.closeView,styles[closeView]]}>
                  <TouchableOpacity
                    onPress={() => {
                      this.props.submitTermsCodition();
                    }}
                  >
                    <Image
                      style={styles.close}
                      source={require("../../assets/images/close.png")}
                    ></Image>
                  </TouchableOpacity>
                </View>
              )}
            </View>
          </LinearGradient>
        )}
      </View>
    );
  }
}

export default HocComponent(Header);
